module.exports = __webpack_public_path__ + "7361c620dc8dc414f0b95e64d16f3998.png";